
export const benefits = {
    '8': [
        {
            module: 'ASISTENCIA HOGAR',
            title: 'Plomería',
            subtitle: '',
            body: "Reparación de roturas de cañerías y llaves, pérdidas, cambio de cueritos y sellado de juntas.",
            tope: "TOPE: $ 11.800 por evento",
            events: "EVENTOS: 3 por año"
        },
        {
            title: 'Electricidad',
            subtitle: '',
            body: "Restablecimiento del servicio de energía eléctrica, revisión e instalación eléctrica, instalación de extractores, cambios de enchufes y teclas, instalación de iluminación.",
            tope: "TOPE: $ 11.800 por evento",
            events: "EVENTOS: 3 por año"
        },
        {
            title: 'Gas',
            subtitle: '',
            body: "En caso de fuga de gas en el domicilio del beneficiario, se enviará un técnico especializado para verificar y solucionar el problema.",
            tope: "TOPE: $ 11.800 por evento",
            events: "EVENTOS: 3 por año"
        },
        {
            title: 'Cerrajería',
            subtitle: '',
            body: "Asistencia para abrir, reparar y asegurar cerraduras en casos de pérdida o robo de llaves, incluyendo cambio y reparación.",
            tope: "TOPE: $ 11.800 por evento",
            events: "EVENTOS: 3 por año"
        },
        {
            title: 'Vidriería',
            subtitle: '',
            body: "Reposición y reparación de vidrios y cristales en puertas y ventanas del hogar, incluyendo daños y roturas.",
            tope: "TOPE: $ 11.800 por evento",
            events: "EVENTOS: 3 por año"
        },
        {
            title: 'Mantenimiento',
            subtitle: '',
            body: "La asistencia incluye visita y presupuesto de pinturería, albañilería (incluyendo Durlock) y control de plagas hasta el límite establecido.",
            tope: "TOPE: $ 11.800 por evento",
            events: "EVENTOS: 1 evento anual"
        },
        {
            module: 'ASISTENCIA MÉDICA',
            title: '',
            subtitle: 'El apoyo que necesitas, directamente desde la comodidad de tu hogar.',
            body: "Podés recibir asistencia médica telefónica primaria según tu solicitud. Tratamos una amplia gama de síntomas, desde resfriados y gripe hasta problemas pediátricos leves, enfermedades del viajero e incluso te brindamos consejería para dejar de fumar.",
            tope: "TOPE: 2 eventos por mes",
            events: "EVENTOS: hasta 24 eventos anuales"
        },
        {
            module: 'ASISTENCIA VETERINARIA',
            title: '',
            subtitle: 'Cuida a tu mascota desde casa.',
            body: "Hacé consultas programadas con veterinarios especializados a través de videollamadas. Te asesoramos sobre problemas de piel, dificultad respiratoria, conductuales, vómitos, diarrea, otitis, conjuntivitis, alergias y consultas prequirúrgicas.",
            tope: "TOPE: 6 eventos anuales",
            events: "MASCOTAS: Gatos, perros, hámster y cobayos."
        },
        {
            module: 'ASISTENCIA TECNOLÓGICA',
            title: '',
            subtitle: "Estamos acá para ayudarte con tu dispositivo.",
            body: "Te ofrecemos configuración, instalación y desinstalación de aplicaciones, sincronización de datos, configuraciones avanzadas, cuentas de usuario, actualización del sistema operativo y asistencia en el uso de software. Además, mejoras de rendimiento, instalación de accesorios y resguardo de información.",
            tope: "TOPE: 6 eventos anuales (en total)",
            events: "",
        },
    ],
    '12': [
        {
            module: 'Asistencias de salud a distancia',
            title: '',
            subtitle: "",
            body: "Acceso a servicios médicos en línea las 24 horas, apoyo psicológico: 6 eventos por año y asesoramiento nutricional.",
            tope: "TOPE: 6 eventos por año están disponibles para brindar asistencia integral.",
            events: "Medico on-line (24hs): hasta 4 eventos por mes / 48 por año.",
        },
        {
            module: 'Visitas o emergencias médicas',
            title: '',
            subtitle: "",
            body: "En caso de enfermedad aguda no urgente, se enviará un médico a la residencia para un diagnóstico preliminar y consejos médicos (Código verde). En caso de emergencia queponga en peligro la vida, se brindará atención médica inmediata y traslado en ambulancia (Código rojo).",
            tope: "TOPE: Emergencias médicas sin límite.",
            events: "",
        },
        {
            module: 'Servicios profesionales de salud',
            title: '',
            subtitle: "",
            body: "Obtené una segunda opinión médica, realiza chequeos de análisis clínicos.",
            tope: "TOPE: Recibí servicios de enfermería con:  Límite: $2500  6 por año cuidado a domicilio. Límite: $2000 6 eventos por año, accede a terapia de kinesiología para una atención completa y personalizada. Límite: $2000 6 eventos por año.",
            events: "",
        },
        {
            module: 'Chequeos de prevención/control',
            title: '',
            subtitle: "",
            body: "Brindamos servicios de prevención y control de salud específicos para mujeres y hombres, así como programas de prevención adaptados a las necesidades de la tercera edad, para promover el bienestar y la calidad de vida en todas las etapas.",
            tope: "",
            events: "",
        },
        {
            module: 'Grandes descuentos',
            title: '',
            subtitle: "",
            body: "Disfruta de un 40% de descuento en ortopedias y ópticas, y un 50% de descuento en farmacias. Además, en caso de emergencia, ofrecemos traslado en taxi para garantizar una respuesta rápida y eficiente.",
            tope: "",
            events: "",
        },
        {
            module: 'Odontología',
            title: '',
            subtitle: "",
            body: "Ofrecemos servicios de odontología de urgencia para atender situaciones dentales urgentes. También brindamos consultas odontológicas especializadas para niños, priorizando su cuidado bucal y bienestar.",
            tope: "Hasta: $2.000 (2 eventos por año).",
            events: "",
        },
    ]
};

